var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.error)?_c('div',{class:['z-hero', _vm.heroClass]},[_c('div',{staticClass:"z-hero__content"},[_c('div',{staticClass:"container"},[_vm._t("breadcrumbs"),_vm._v(" "),_c('h1',{staticClass:"z-hero__title",domProps:{"innerHTML":_vm._s(_vm.heroTitle)}})],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }